import {useEffect, useState} from "react";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {getUserRole} from "../../../../services/auth.service";
import ClientsService from "../../../../services/clients.service";
import {borrowKeyColumns, contractorColumns, keyColumns} from "../../../../components/Utils/HeaderColumns";
import KeysService from "../../../../services/keys.service";
import MDBadge from "../../../../components/MDBadge";
import GHIconButton from "../../../../components/GHIconButton";
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Icon from "@mui/material/Icon";
import MDButton from "../../../../components/MDButton";
import MDSnackbar from "../../../../components/MDSnackbar";
import Modal from "@mui/material/Modal";
import MDBox from "../../../../components/MDBox";
import {modalStyleAds} from "../../../../components/Utils/ModalStyle";
import Card from "@mui/material/Card";
import MDTypography from "../../../../components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "../../../../components/MDInput";
import TextField from "@mui/material/TextField";
import DataTable from "../../../../examples/Tables/DataTable";
import DashboardLayout from "../../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../../examples/Navbars/DashboardNavbar";
import Footer from "../../../../examples/Footer";
import { saveAs } from "file-saver";

function BorrowKey() {
    const defaultInputValues = { description:"" , endTime: "2023-01-01T08:00", startTime: "2023-01-01T16:00"};

    const [values, setValues] = useState(defaultInputValues);

    const validationSchema = Yup.object().shape({
        description: Yup.string()
            .required('Description is required'),
        startTime: Yup.string(),
        endTime: Yup.string(),
    });

    const { register, handleSubmit, formState: { errors  } } =
            useForm({mode:"all", resolver:yupResolver(validationSchema)});

    const handleChange = (value) => {
        setValues(value);
        setIsValid(validationSchema.isValidSync(values));

    };

    const [isValid, setIsValid] = useState(false);

    const [selectedInstance, setSelectedInstance] = useState({});
    const [units, setUnits] = useState([]);
    const [keys, setKeys] = useState([]);
    const [traders, setTraders] = useState([]);
    const [buildings, setBuildings] = useState([]);
    const [clients, setClients] = useState([]);

    const [openDialog, setOpenDialog] = useState(false);

    const [infoSB, setInfoSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const openErrorSB = () => setErrorSB(true);
    const closeErrorSB = () => setErrorSB(false);
    const openInfoSB = () => setInfoSB(true);
    const closeInfoSB = () => setInfoSB(false);
    const [errorMessage, setErrorMessage] = useState("");
    const isAdmin = getUserRole() === "super_admin"
    useEffect(() => {
        loadClients();
        loadBorrow();
        loadTrader();
    }, [setClients, setBuildings, setUnits]);

    const loadClients = (instance_id) => {
        ClientsService.getClients(instance_id)
        .then((res) => {
            console.log(res.data);
            setClients(res.data);
            if (res.data.length > 0){
                loadBuilding(res.data[0].id);
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const loadBuilding = (client_id) => {
        ClientsService.getClientsBuilding(client_id)
        .then((res) => {
            console.log(res.data);
            setBuildings(res.data);
            if(res.data.length > 0){
    loadKey(res.data[0].id);
}
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const loadKey = (building_id) => {
        KeysService.getKeys(building_id)
        .then((res) => {
            console.log(res.data);
            if (res.data === null ||res.data === undefined){
                res.data  = []
            }
            setKeys(res.data);
            // loadProvince(res.data[0]);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const loadTrader = () => {
        KeysService.getTraders()
        .then((res) => {
            console.log(res.data);
            setTraders(res.data);
        })
        .catch((error) => {
            console.log(error);
        });
    }



    const [borrowKeyTableData, setBorrowKeyTableData] =
                        useState({"columns" :
                            borrowKeyColumns, "rows":[]});

    const loadBorrow = () => {
        setBorrowKeyTableData({"columns" : borrowKeyColumns, "rows":[]})
        KeysService.getBorrows()
        .then((res) => {
            console.log(res.data);
            setBorrowKeyTableData( {
                "columns": borrowKeyColumns,
                "rows": res.data.map(function(element) {
                        return {
                              id: element.id,
                              key: element.key,
                              trader: element.trader,
                              client: element.client,
                              building: element.building,
                              borrowTime: element.borrow_time,
                              backTime: element.back_time,
                              status: <MDBadge badgeContent={"BorrowBack"} size="sm" container
                                       color={element.status === "active" ? "success" : "dark"} />,
                              action: (
                                  <div>

                                      <GHIconButton onClick={handleClickItem} id={ element.id} action={"delete"}
                                                    rowName={element.client_name} title={"Remove"} color={"error"}
                                                    icon={"delete"} size={"medium"} />

                                  </div>
                              ),
                            }
                    })
            })

        })
        .catch((error) => {
          console.log(error);
        });
    }

    const [clickedItemId, setClickedItemId] = useState(0);

    const [openInsertModel, setOpenInsertModel] = useState(false);
    const [openUserModel, setOpenUserModel] = useState(false);

    const handleOpen = (event, model) => {
        switch (model){
            case "insert":
                setOpenInsertModel(true);
                break;
            case "delete" :
                handleOpenDialog(model);
                break;
            case "change_status":
                handleOpenDialog(model);
                break;
        }
    }
    const handleClose = (model) => {
        switch (model){
            case "insert":
                setOpenInsertModel(false);
                break;
        }
    }


    const [dialogAction, setDialogAction] = useState("")
    const handleOpenDialog = (action) => {
        setOpenDialog(true);
        setDialogAction(action)
    }
    const handleCloseDialog = () => setOpenDialog(false);

    const handleAgreeDeleteDialog = () => {
        if (dialogAction === "delete") {
            KeysService.removeBorrow(clickedItemId)
                .then((response) => {
                    openInfoSB();
                    window.location.reload();
                })
                .catch((err) => {
                    console.log(err);
                    setErrorMessage(err);
                    openErrorSB();
                });

        }
    }


    function handleClickItem(elem) {
        let actionToDo = elem.target.getAttribute("action");
        let rowName = elem.target.getAttribute("rowname");
        let rowId = elem.target.id;
        // alert(rowId)
        setClickedItemId(rowId);
        setSelectedClientTitle(rowName);
        switch (actionToDo) {
            case "edit":
                handleOpen(elem,"edit");
                break;
            case "change_status":
                handleOpen(elem,"change_status");
                break;
            case "delete":
                handleOpen(elem,"delete");
                break;
        }
    }

    const [userTableData, setUserTableData] = useState({});
    const [selectedClientTitle, setSelectedClientTitle] = useState("");

    const renderDialog = () => {
        return (
            <Dialog
                open={openDialog}
                keepMounted
                onClose={handleCloseDialog}
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle><Icon color={"warning"} >warning</Icon>{" Delete/Disable confirmation"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Are you sure to Delete/Disable this item ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MDButton onClick={handleCloseDialog} >Disagree</MDButton>
              <MDButton onClick={handleAgreeDeleteDialog}  size={"large"}  color={"info"}  >Agree</MDButton>
            </DialogActions>
          </Dialog>
        )
    }


    const saveDataClicked = (e) =>{
    e.preventDefault();

    if(isValid){

        let dataToSend = {
            trader_id: values.trader.id,
            key_id: values.key.id,
            description: values.description,
            borrow_date: values.startTime,
            back_time: values.endTime
        }

        console.log(dataToSend);

        KeysService.insertBorrow(dataToSend)
            .then((response) =>{
                console.log(response);
                openInfoSB();
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.status.toString());
                openErrorSB();
            });
    }
}

    const renderSB = (
        <div>
            <MDSnackbar
              color="success"
              icon="notifications"
              title="Amenity System"
              content="Your data saved successfully"
              dateTime=""
              open={infoSB}
              onClose={()=>setInfoSB(false)}
              close={()=>setInfoSB(false)}  />

            <MDSnackbar
              color="error"
              icon="error"
              title="Amenity System"
              content={errorMessage}
              dateTime=""
              open={errorSB}
              onClose={()=>setErrorSB(false)}
              close={()=>setErrorSB(false)}/>
        </div>
    );
    const [editMode, setEditMode] = useState(false);
    const renderInsertModal = () => {
        return <Modal open={openInsertModel} onClose={(e)=>{handleClose("insert")}} color={"warning"} >
          <MDBox sx={modalStyleAds}>
            <Card id="basic-info" sx={{ overflow: "visible" }}>
              <MDBox p={3}>
                <MDTypography variant="h5" >{editMode ? "Edit Key": "Borrow Key"}</MDTypography>
              </MDBox>
              <MDBox component="form" pb={3} px={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                          required
                          options={clients}
                          value={values.client}
                          clearIcon={false}
                          clearOnBlur={false}
                          contentEditable={false}
                          getOptionLabel={(option) => option.client_name ?? "loading...."}
                          onChange={(event,value) => {
                            setValues({ ...values, client: value });
                            loadBuilding(value.id);
                          }}
                          renderInput={(params) => (
                            <MDInput {...params}
                                        error={!!errors.client}
                                        helperText={errors.client?.message}
                                        label="Client"
                                        InputLabelProps={{ shrink: true }}
                                        {...register("client")}/>
                          )}
                        />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                          required
                          options={buildings}
                          value={values.building}
                          clearIcon={false}
                          contentEditable={false}
                          getOptionLabel={(option) => option.name ?? "loading...."}
                          onChange={(event,value) => {
                            handleChange({ ...values, building: value });
                            loadKey(value.id);
                          }}
                          renderInput={(params) => (
                            <MDInput {...params}
                                        error={!!errors.building}
                                        helperText={errors.building?.message}
                                        label="Building"
                                        InputLabelProps={{ shrink: true }}
                                        {...register("building")} />
                          )}
                        />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                          required
                          options={keys}
                          value={values.key}
                          clearIcon={false}
                          contentEditable={false}
                          getOptionLabel={(option) => option.key_name ?? "loading...."}
                          onChange={(event,value) => {
                            handleChange({ ...values, key: value });
                          }}
                          renderInput={(params) => (
                            <MDInput {...params}
                                        error={!!errors.key}
                                        helperText={errors.key?.message}
                                        label="Key"
                                        InputLabelProps={{ shrink: true }}
                                        {...register("key")} />
                          )}
                        />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                          required
                          options={traders}
                          value={values.trader}
                          clearIcon={false}
                          contentEditable={false}
                          getOptionLabel={(option) => option.name ?? "loading...."}
                          onChange={(event,value) => {
                            handleChange({ ...values, trader: value });
                          }}
                          renderInput={(params) => (
                            <MDInput {...params}
                                        error={!!errors.trader}
                                        helperText={errors.trader?.message}
                                        label="Contractor"
                                        InputLabelProps={{ shrink: true }}
                                        {...register("trader")} />
                          )}
                        />
                  </Grid>
                  <Grid item xs={12} md={12}>

                    <TextField
                          fullWidth
                          required
                          error={!!errors.description}
                          helperText={errors.description?.message}
                          value={values.description}
                          {...register("description")}
                          onChange={(event) => {
                            handleChange({ ...values, description: event.target.value })
                          }}
                        label="Description"
                        placeholder="Description about this borrow"  />
                  </Grid>
                  <Grid item xs={12} md={6}>

                    <TextField
                          fullWidth
                          required
                          type={"datetime-local"}
                          variant={"standard"}
                          error={!!errors.startTime}
                          helperText={errors.startTime?.message}
                          value={values.startTime}
                          {...register("startTime")}
                          onChange={(event) => {
                            handleChange({ ...values, startTime: event.target.value })
                          }}
                        label="Start Time (or place name)" />
                  </Grid>
                  <Grid item xs={12} md={6}>

                    <TextField
                          fullWidth
                          required
                          type={"datetime-local"}
                          variant={"standard"}
                          error={!!errors.endTime}
                          helperText={errors.endTime?.message}
                          value={values.endTime}
                          {...register("endTime")}
                          onChange={(event) => {
                            handleChange({ ...values, endTime: event.target.value })
                          }}
                        label="End Time (or place name)" />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <MDButton disabled={!isValid} color={"info"} size={"large"}
                              onClick={saveDataClicked} >Save Data</MDButton>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </MDBox>
        </Modal>
    };


    const handleDownloadCsv = (e) => {saveAs(process.env.PUBLIC_URL + "/resource/template.csv", "template.csv");};
    const borrowKeysList = () => {
        return(
            <MDBox my={3}>
              {renderSB}
              {renderInsertModal()}
              {renderDialog()}
              <MDBox  display="flex" justifyContent="space" alignItems="flex-start" mb={2}>
                  <MDButton variant="gradient" color="warning" size="large"
                            disabled={selectedInstance.id === ""} onClick={(e) => {handleOpen(e,"insert")}}>
                    borrow key
                  </MDButton>
              </MDBox>
              <Card>
                    <DataTable showTotalEntries={true}
                       table={borrowKeyTableData}
                       entriesPerPage={false}
                       canSearch />
              </Card>
            </MDBox>
        )
    };

    return (
        <DashboardLayout>
          <DashboardNavbar />
            {borrowKeysList()}
          <Footer />
        </DashboardLayout>
    );

}

export default BorrowKey;